const NAV_LINKS = [
  {
    id: 'aboutus',
    label: 'ABOUT US',
    offset: -50,
  },
  {
    id: 'brands',
    label: 'BRANDS',
    offset: -55,
  },
  {
    id: 'contactus',
    label: 'CONTACT US',
    offset: -20,
  },
]

export default NAV_LINKS
